<template>
  <v-dialog v-model="active" persistent max-width="600px">
    <template #activator="{ on }">
      <slot name="activator" :on="on" />
    </template>
    <v-card>
      <div class="float-right mt-4 mr-4">
        <file-picker-button
          type="mission"
          :type-id="mission.id"
          @upload-start="() => $store.commit('startLoading')"
          @upload-end="() => $store.commit('endLoading')"
          v-if="mission.id"
        >
          <template #default="{ on, loading }">
            <v-btn v-on="on" :loading="loading" light block>
              PHOTO
            </v-btn>
          </template>
        </file-picker-button>
      </div>
      <v-card-title>
        <span class="headline">MISSION {{ mission.id | numeral("000000") }}</span>
      </v-card-title>
      <v-card-text>
        <v-form lazy-validation ref="form">
          <v-text-field :value="mission.status" label="Status" dense readonly />
          <mission-form-start-fields :form.sync="formStart" :mission="mission" />
        </v-form>
        <!-- <v-text-field
          v-model="form.weightStart"
          label="Full Weight"
          type="number"
        />
        <v-text-field
          v-model="form.weightEnd"
          label="Decanted Weight"
          type="number"
        />
        <v-text-field
          v-model="form.weightEmpty"
          label="Empty Weight"
          type="number"
        /> -->
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text :disabled="loading" @click="active = false">
          CANCEL
        </v-btn>
        <v-btn text :disabled="loading" :loading="loading" @click="submit">
          SUBMIT
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { denormalize } from "@/helpers/JsonApiDenormalizer";
import { MissionService } from "@/services/mission.service";
import FilePickerButton from "@/components/File/FilePickerButton";
import MissionFormStartFields from "@/components/Mission/MissionFormStartFields";

export default {
  props: {
    mission: {
      required: true
    },
    messageSuccess: {
      type: String,
      default: "Mission has been ended."
    }
  },
  components: {
    FilePickerButton,
    MissionFormStartFields
  },
  data: () => ({
    form: {
      weightStart: "",
      weightEnd: "",
      weightEmpty: ""
    },
    formStart: {},
    active: false,
    loading: false
  }),
  created() {
    this.setForm();
  },
  watch: {
    mission() {
      this.setForm();
    }
  },
  methods: {
    open() {
      this.active = true;
    },
    close() {
      this.active = false;
    },
    setForm() {
      // this.form.weightStart = this.mission.weightStart || "";
      // this.form.weightEnd = this.mission.weightEnd || "";
      // this.form.weightEmpty = this.mission.weightEmpty || "";
    },
    transformed() {
      return {
        name: this.formStart.name,
        third_party_code: this.formStart.thirdPartyCode || undefined,
        inspected_by: this.formStart.inspectedBy || undefined,
        data: this.formStart.data || undefined,
        // weight_start: this.form.weightStart,
        // weight_end: this.form.weightEnd,
        // weight_empty: this.form.weightEmpty
      };
    },
    async submit() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;

      try {
        const mission = await MissionService.finish(
          this.mission.id,
          this.transformed()
        ).then(response => denormalize(response.data));

        this.$store.commit("snacktime", {
          text: this.messageSuccess
        });

        this.$emit("submit", mission);
        this.close();
      } catch (err) {}

      this.loading = false;
    }
  }
};
</script>
